import axios from "axios";
import type { AIResponseType, DocumentItem, RequestType } from "../../types/rfq";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:9000";

const API_BASE_URL = `${BACKEND_URL.replace(/\/$/, "")}/api/rfq`;
const API_BASE_URL_AI = `${BACKEND_URL.replace(/\/$/, "")}/api`;

export const buildRfqFormData = (request: RequestType): FormData => {
  const formData = new FormData();

  Object.keys(request).forEach((key) => {
    const value = (request as any)[key];

    if (key === "documents") {
      (value || []).forEach((doc: DocumentItem) => {
        if (doc?.file instanceof File) {
          formData.append("documents", doc.file);
        }
      });

      formData.append(
        "documents_meta",
        JSON.stringify(
          (value || []).map((doc: any) => ({
            name: doc?.file?.name || doc?.original_name || doc?.stored_name || "",
            type: doc?.type || doc?.doc_type || "",
          })),
        ),
      );
      return;
    }

    if (Array.isArray(value)) {
      formData.append(key, JSON.stringify(value));
      return;
    }

    if (value !== undefined && value !== null && value !== "") {
      formData.append(key, String(value));
    }
  });

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  if (user?.id_user) {
    formData.append("user_id", String(user.id_user));
  }

  return formData;
};

export const submitRfq = async (request: RequestType) => {
  const formData = buildRfqFormData(request);

  return axios.post(`${API_BASE_URL}/add`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getRfqById = async (id: string | number) => {
  return axios.get(`${API_BASE_URL}/${id}`);
};

export const updateRfq = async (id: string | number, request: RequestType) => {
  const formData = buildRfqFormData(request);

  return axios.put(`${API_BASE_URL}/edit/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const fillRfqWithAI = async (
  description: string,
): Promise<AIResponseType> => {
  const response = await axios.post(`${API_BASE_URL_AI}/ai/rfq-fill`, {
    description,
  });
  return response.data?.data || response.data || {};
};
